var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 9.5C8.00012 8.67157 8.67169 8 9.50012 8C10.3285 8 11.0001 8.67157 11.0001 9.5C11.0001 10.3284 10.3285 11 9.50012 11C8.67169 11 8.00012 10.3284 8.00012 9.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 9.5C13.0001 8.67157 13.6717 8 14.5001 8C15.3285 8 16.0001 8.67157 16.0001 9.5C16.0001 10.3284 15.3285 11 14.5001 11C13.6717 11 13.0001 10.3284 13.0001 9.5Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 13C13.6717 13 13.0001 13.6716 13.0001 14.5C13.0001 15.3284 13.6717 16 14.5001 16C15.3285 16 16.0001 15.3284 16.0001 14.5C16.0001 13.6716 15.3285 13 14.5001 13Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 14.5C8.00012 13.6716 8.67169 13 9.50012 13C10.3285 13 11.0001 13.6716 11.0001 14.5C11.0001 15.3284 10.3285 16 9.50012 16C8.67169 16 8.00012 15.3284 8.00012 14.5Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.09961C9.26654 2.09961 6.7903 3.20869 4.99974 4.99925C3.20918 6.78981 2.1001 9.26605 2.1001 11.9996C2.1001 14.7332 3.20918 17.2094 4.99974 19C6.7903 20.7905 9.26654 21.8996 12.0001 21.8996C14.7337 21.8996 17.2099 20.7905 19.0005 19C20.791 17.2094 21.9001 14.7332 21.9001 11.9996C21.9001 9.26605 20.791 6.78981 19.0005 4.99925C17.2099 3.20869 14.7337 2.09961 12.0001 2.09961ZM6.27253 6.27204C7.73933 4.80525 9.76309 3.89961 12.0001 3.89961C14.2371 3.89961 16.2609 4.80525 17.7277 6.27204C19.1945 7.73884 20.1001 9.76261 20.1001 11.9996C20.1001 14.2366 19.1945 16.2604 17.7277 17.7272C16.2609 19.194 14.2371 20.0996 12.0001 20.0996C9.7631 20.0996 7.73933 19.194 6.27253 17.7272C4.80574 16.2604 3.9001 14.2366 3.9001 11.9996C3.9001 9.76261 4.80574 7.73884 6.27253 6.27204Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudOutline);
export default __webpack_public_path__ + "static/media/stud_outline.8b2b205419a4d826e10114ec51d718fd.svg";
export { ForwardRef as ReactComponent };